import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { ProjectHeader } from "../../components/project";
import { AddPerformanceGuarantees, PerformanceGuaranteesList } from "../../components/performanceGuarantee";
import { CREATE_PERFORMANCE_GUARANTEE } from "../../constants";
import { useHasPermission } from "../../utils";

export const ProjectPerformanceGuarantees = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const { id } = useParams();
  const hasPgCreate = useHasPermission(CREATE_PERFORMANCE_GUARANTEE);

  const handleModalClose = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasPgCreate && { icon: <Add />, buttonText: "Add PG & AD PG", tooltip: "Add PG & AD PG", onClick: () => setOpenModal(true) },
  ];
  return (
    <>
      <PageLayout>
        <Box sx={{ position: "relative", zIndex: 1, marginTop: "22px" }}>
          <ProjectHeader title={`Project Performance Guarantees (${totalCount})`} actionButtons={buttons} />
        </Box>
        <PerformanceGuaranteesList projectId={id} totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
      </PageLayout>

      {/* add pg and ad pg modal */}
      <AddPerformanceGuarantees open={openModal} projectId={id} onClose={handleModalClose} onSuccess={handleReload} />
    </>
  );
};
